import type { FC } from "react";
import SortingArrows from "components/Sorting/Arrows";

interface Props {
  sort: (type: string, by: "asc" | "desc") => void;
  activeSort: { type: string; direction: "asc" | "desc" } | null;
}

const ThemeRowHead: FC<Props> = ({ sort, activeSort }) => (
  <div className="theme-row theme-row--head">
    <div className="theme-row__size--large text-start">Téma</div>
    <div className="theme-row__size--medium d-flex flex-row">
      <span>Prům. body v&nbsp;1&nbsp;testu</span>
      <SortingArrows type="points" activeSort={activeSort} onChange={sort} />
    </div>
    <div className="theme-row__size--medium d-flex flex-row">
      Úlohy v&nbsp;obálkách <SortingArrows type="envelopes" activeSort={activeSort} onChange={sort} />
    </div>
    <div className="theme-row__size--medium">Postup</div>
  </div>
);

export default ThemeRowHead;
